// Common response handler
export const handleResponse = async (response, format = "json") => {
  const status = response.status;
    
  let responseData;

  if (format === 'json') {
    responseData = await response.json();
  } else if (format === 'text') {
    responseData = await response.text();
  } else if (format === 'blob') {
    responseData = await response.blob();
  }

  if (!response.ok) {
    const errorMsg = typeof responseData === 'object'
      ? responseData.message || responseData?.errorMessage || ''
      : responseData;

    throw new Error(errorMsg);
  }
  return { status, data: responseData };
};

export const defaultHeaders = {
  'Content-Type': 'application/json',
  "x-auth-token": window.appAuthToken
};